var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pt-6", attrs: { id: "slides" } },
    [
      _c("b-container", { staticClass: "position-relative px-0" }, [
        _c(
          "div",
          {
            ref: "slidesContainer",
            style: { height: _vm.slideHeight + "px" },
            attrs: { id: "slidesContainer" },
          },
          [
            _c(
              "div",
              {
                staticClass: "slides",
                style: { width: _vm.totalContainerWidth + "px" },
              },
              _vm._l(_vm.slides, function (slide, key) {
                return _c("div", {
                  key: key,
                  staticClass: "slide bg-cover bg-scroll",
                  class: [
                    _vm.currentSlide && _vm.currentSlide.id === slide.id
                      ? "active"
                      : "",
                    _vm.live ? "cursor-zoom-in" : "cursor-pointer",
                  ],
                  style: {
                    backgroundImage: "url(" + _vm.slideUrl(slide) + ")",
                    width: _vm.slideWidth + "px",
                    height: _vm.slideHeight + "px",
                    marginRight:
                      key + 1 !== _vm.slides.length
                        ? _vm.slideGutter + "px"
                        : "",
                  },
                  attrs: {
                    "data-key": key,
                    "data-id": slide.id,
                    "data-slideid": slide.slide_id,
                  },
                  on: {
                    click: function ($event) {
                      _vm.live
                        ? _vm.zoomSlide(slide)
                        : _vm.seekToTime(slide.timecode)
                    },
                  },
                })
              }),
              0
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }